import { fields, form, zodValidator } from '@codeleap/form'
import { z } from 'zod'
import { loadI8n } from '../i18n'

loadI8n()

import { t } from '@lingui/core/macro'

export const post = form('post', {
  title: fields.text({
    placeholder: t`Title`,
    validate: zodValidator(z.string().min(6).max(128))
  }),
  content: fields.text({
    placeholder: t`Content`,
    validate: zodValidator(z.string().min(6).max(250)),
    multiline: true,
  }),
})

export const editPost = form('editPost', {
  title: fields.text(post.fields.title.options),
  content: fields.text(post.fields.content.options),
})